import { render } from "./AuthLayout.vue?vue&type=template&id=05999886&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=05999886&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05999886"]])

export default __exports__